import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import ActionIconButton from '@components/ActionIconButton';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import withStopPropagation from './withStopPropagation';

const Header = styled('div')(({ padding }) => ({
    padding,
    flexShrink: 0,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
}));

const TitleRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
});

const TitleText = styled('div')({
    flex: 1,
    minWidth: 0,
    overflowX: 'hidden',
});

const Subtitle = styled('div')({
    marginTop: 4,
});

const HeaderIconButton = styled(IconButton)({
    padding: 8,
    margin: -8,
    color: 'var(--text-secondary)',
});

const ModalHeader = ({
    title,
    titleId,
    subtitle,
    subtitleId,
    titleVariant = 'h6',
    padding = 16,
    onBack,
    onClose,
    closeDisabled = false,
    className,
}) => {
    const { t } = useTranslation();

    return (
        <Header className={className} padding={padding}>
            <TitleRow>
                {onBack && (
                    <ActionIconButton
                        title={t('buttons.back')}
                        component={HeaderIconButton}
                        onClick={withStopPropagation(onBack)}
                    >
                        <ArrowBackIcon />
                    </ActionIconButton>
                )}
                <TitleText>
                    <Typography id={titleId} variant={titleVariant} color="textPrimary">
                        {title}
                    </Typography>
                </TitleText>
                {onClose && (
                    <ActionIconButton
                        title={t('buttons.close')}
                        component={HeaderIconButton}
                        disabled={closeDisabled}
                        onClick={withStopPropagation(onClose)}
                    >
                        <CloseIcon />
                    </ActionIconButton>
                )}
            </TitleRow>
            {subtitle && (
                <Subtitle>
                    <Typography id={subtitleId} variant="caption" color="textSecondary" component="div">
                        {subtitle}
                    </Typography>
                </Subtitle>
            )}
        </Header>
    );
};

export default ModalHeader;
